import {selectFunctions} from "./select";
import {calendarFunctions} from "./calendar";
import {dadataFunctions} from "./dadata";
import {inputFunctions} from "./input";

export const componentsFunctions = () => {
  calendarFunctions();
  selectFunctions();
  dadataFunctions();
  inputFunctions();
};
